/**
 * Route configuration with localized paths
 * Maps internal route keys to localized URL paths for each language
 */

export const routeConfig = {
  home: {
    nl: '/',
    en: '/',
    fr: '/',
    de: '/'
  },
  services: {
    nl: 'diensten',
    en: 'services',
    fr: 'services',
    de: 'leistungen'
  },
  portfolio: {
    nl: 'portfolio',
    en: 'portfolio',
    fr: 'portfolio',
    de: 'portfolio'
  },
  pricing: {
    nl: 'prijzen',
    en: 'pricing',
    fr: 'tarifs',
    de: 'preise'
  },
  faq: {
    nl: 'faq',
    en: 'faq',
    fr: 'faq',
    de: 'faq'
  },
  blog: {
    nl: 'blog',
    en: 'blog',
    fr: 'blog',
    de: 'blog'
  },
  contact: {
    nl: 'contact',
    en: 'contact',
    fr: 'contact',
    de: 'kontakt'
  },
  privacy: {
    nl: 'privacy',
    en: 'privacy',
    fr: 'confidentialite',
    de: 'datenschutz'
  },
  terms: {
    nl: 'voorwaarden',
    en: 'terms',
    fr: 'conditions',
    de: 'agb'
  },
  serviceDescription: {
    nl: 'dienstbeschrijving',
    en: 'service-description',
    fr: 'description-service',
    de: 'dienstbeschreibung'
  },
  casestudy: {
    nl: 'portfolio',
    en: 'portfolio',
    fr: 'portfolio',
    de: 'portfolio'
  }
};

// Supported languages
export const supportedLanguages = ['nl', 'en', 'fr', 'de'];

// Default language
export const defaultLanguage = 'nl';

/**
 * Get localized path for a route
 * @param {string} routeKey - The route key (e.g., 'services')
 * @param {string} lang - The language code
 * @returns {string} - The full localized path (e.g., '/en/services')
 */
export const getLocalizedPath = (routeKey, lang) => {
  const route = routeConfig[routeKey];
  if (!route) return `/${lang}`;
  
  const path = route[lang] || route[defaultLanguage];
  if (path === '/') return `/${lang}`;
  return `/${lang}/${path}`;
};

/**
 * Get route key from a path segment
 * @param {string} pathSegment - The path segment (e.g., 'diensten')
 * @returns {string|null} - The route key or null if not found
 */
export const getRouteKeyFromPath = (pathSegment) => {
  if (!pathSegment) return 'home';
  
  for (const [key, paths] of Object.entries(routeConfig)) {
    for (const path of Object.values(paths)) {
      if (path === pathSegment) {
        return key;
      }
    }
  }
  return null;
};

/**
 * Get all localized paths for navigation
 * @param {string} lang - The language code
 * @returns {object} - Object with route keys and their localized paths
 */
export const getNavigationPaths = (lang) => {
  const paths = {};
  for (const [key, route] of Object.entries(routeConfig)) {
    const path = route[lang] || route[defaultLanguage];
    paths[key] = path === '/' ? `/${lang}` : `/${lang}/${path}`;
  }
  return paths;
};
